import _ from 'lodash'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, Redirect, useHistory, useLocation } from 'react-router-dom'

import { getCurrentApp, getCurrentAppId } from 'e-submission/apps/selectors'
import App from 'e-submission/containers/App'
import AppForm from 'e-submission/containers/AppForm'
import AppList from 'e-submission/containers/AppList'
import Dialog from 'e-submission/containers/Dialog'
import OTPDialog from 'e-submission/containers/Dialog/OTP'
import { APP_STATUS } from 'e-submission/domain/data-model/constants'
import { getAppStatus, getIsOnOtp } from 'e-submission/domain/data-model/form/selectors'

const redirect = function(path) {
  return function CustomRedirect(props) {
    const history = useHistory()
    useEffect(() => {
      history.replace(path)
    }, [])
    return <></>
  }
}

function OTP() {
  const { currentAppId } = useSelector((state) => ({ currentAppId: getCurrentAppId(state) }))

  if (!currentAppId) {
    return redirect('/e-submission/list')
  }

  return <OTPDialog isOpen={true} backUrl="/e-submission/list" nextUrl="/e-submission/form/submit" />
}

function AppForms(props) {
  const { match } = props
  const appState = useSelector((state) => {
    const app = getCurrentApp(state)
    return {
      currentAppId: getCurrentAppId(state),
      status: getAppStatus(app),
      isOnOtp: getIsOnOtp(app),
      remoteSelling: false,
    }
  })

  if (_.isEmpty(appState.currentAppId)) {
    return redirect('/')
  }

  if (!_.endsWith(match.url, 'otp') && status === APP_STATUS.SIGNED && appState.isOnOtp) {
    return redirect('otp')
  }

  if (!appState.remoteSelling && !_.includes(match.url, 'submit') && status === APP_STATUS.SIGNED) {
    return redirect('submit')
  }
  const location = useLocation()
  return <AppForm {...appState} match={match} location={location} />
}

const routes = [
  {
    path: '/list',
    component: AppList,
  },
  {
    path: '/form/otp',
    component: OTP,
  },
  {
    path: '/form/:pageId/:subpage?',
    component: AppForms,
  },
]

export default ({ match }) => (
  <App>
    <Dialog />
    <Switch>
      {routes.map(({ path, component }) => (
        <Route key={path} path={match.url + path} component={component} />
      ))}
      <Redirect from="/" to={match.url + '/form/insured'} />
    </Switch>
  </App>
)
